import { createAsyncThunk } from "@reduxjs/toolkit";

import { updateOrganizationAddressRequest } from "Api/organizations/address/updateOrganizationAddress.request";
import logger from "Libs/logger";

import type { OrganizationAddress } from "Api/organizations/address/types";
import type { AsyncThunkOptionType } from "Reducers/types";

export const updateOrganizationAddress = createAsyncThunk<
  OrganizationAddress,
  { organizationId: string; updates: Partial<OrganizationAddress> },
  AsyncThunkOptionType
>(
  "app/organization/update_organization_address",
  async ({ organizationId, updates }, { rejectWithValue }) => {
    try {
      const address = await updateOrganizationAddressRequest(
        organizationId,
        updates
      );

      return address;
    } catch (error: unknown) {
      logger(error, {
        action: "update_organization_address",
        organizationId
      });

      return rejectWithValue(error);
    }
  }
);
